module.exports = __webpack_public_path__ + "static/media/Icono almacenamiento.3a2eb893.svg";